import { render, staticRenderFns } from "./EvrakIndirIslemDetayView.vue?vue&type=template&id=f4235f66&scoped=true"
import script from "./EvrakIndirIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./EvrakIndirIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4235f66",
  null
  
)

export default component.exports